import axios from 'axios';
import authHeader from '../_helpers/auth-header';

const API_URL = process.env.VUE_APP_API_URL;

class SponsorService {
  get(params) {
    return axios.get(API_URL + 'sponsor-tim/' + params, { headers: authHeader() });
  }

  add(data) {
    return axios.post(API_URL + 'sponsor-tim', data, { headers: authHeader() });
  }

  delete(id) {
    return axios.delete(API_URL + 'sponsor-tim/' + id, { headers: authHeader() });
  }
}

export default new SponsorService();